import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { Router,NavigationEnd,ActivatedRoute } from '@angular/router';
declare  var jQuery:  any;

@Component({
  selector: 'app-bookingconfirm',
  templateUrl: './bookingconfirm.component.html',
  styleUrls: ['./bookingconfirm.component.scss']
})
export class BookingconfirmComponent implements OnInit {

	is_authenticate_user: boolean = false;

  constructor(
  public authService: AuthService,
    private router: Router,
    ) { }

  ngOnInit(): void {

  	if(this.authService.isLoggedIn == true)
    {
      this.is_authenticate_user = true;
      //this.loginactivefunction();
    }else{
 	 this.router.navigate(['/singin']);
    }
  }

}
